// Attribue une couleur stable à chaque genre (même genre = toujours la même
// couleur, sans avoir à maintenir une liste manuelle pour chacun).
const PALETTE = [
  '#E74C3C', '#F04E1A', '#F39C12', '#D4AF37', '#5A9E7A', '#16A085',
  '#3B6FBF', '#2980B9', '#9B59B6', '#8E44AD', '#E91E63', '#795548',
];

const cache = {};

export function genreColor(genre) {
  if (!genre) return '#B5A99A';
  if (cache[genre]) return cache[genre];
  let hash = 0;
  for (let i = 0; i < genre.length; i++) hash = (hash * 31 + genre.charCodeAt(i)) >>> 0;
  const color = PALETTE[hash % PALETTE.length];
  cache[genre] = color;
  return color;
}
